import { render, staticRenderFns } from "./SupportTicketDialogAssignedTo.vue?vue&type=template&id=97958b04"
import script from "./SupportTicketDialogAssignedTo.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogAssignedTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports